import { render, staticRenderFns } from "./visitRecord.vue?vue&type=template&id=6c1779fe&scoped=true&"
import script from "./visitRecord.vue?vue&type=script&lang=js&"
export * from "./visitRecord.vue?vue&type=script&lang=js&"
import style0 from "./visitRecord.vue?vue&type=style&index=0&id=6c1779fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c1779fe",
  null
  
)

export default component.exports